let menuLiSelector = document.querySelectorAll(".header__menu_li");

menuLiSelector.forEach((item) => {
  if (item.classList.contains("menu__item_has_children")) {
    let menuItemUrl = "";
    let menuItemLocation = "";
    let listDetails = item.querySelector("details");
    let summaryElement = item.querySelector("summary");

    // Mouseover for both the summary and the details (dropdown) elements
    item.addEventListener("mouseover", () => {
      listDetails.setAttribute("open", "");
      summaryElement.setAttribute("aria-expanded", true);
    });

    // Mouseleave for the entire menu item (including dropdown)
    item.addEventListener("mouseleave", () => {
      listDetails.removeAttribute("open");
      summaryElement.setAttribute("aria-expanded", false);
    });

    // Click handler for the summary
    summaryElement.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      menuItemUrl = summaryElement.dataset.href;
      menuItemLocation = `${menuItemUrl}`;

      if (listDetails.hasAttribute("open")) {
        location.href = menuItemLocation;
      }
    });
  }
});
